import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Card from './Components/Card'

function App() {
  return (
    <div className="App">
      <Card />
    </div>
  );
}

export default App;
